import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getResources } from 'api/requests';


export const fetchResources = createAsyncThunk(
    'resources/fetchResources',
    async ({ language = 'uk', country = 'uk' } = {}) => {
        try {
            console.log('language', language);
            const response = await getResources(language, country);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

const resourcesSlice = createSlice({
    name: 'resources',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchResources.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchResources.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchResources.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default resourcesSlice.reducer;
